import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentPageComponent, FeatureFlagGuard, SupportIssuesPage, UserGuard } from 'army-builder-shared';

import { HomePage } from './home/home.page';
import { FalloutSubscriptionPageModule } from './subscription-page/subscription-page.module';
import { FalloutSettingsModule } from './settings/settings.module';
import { SUBSCRIPTION_PAGE_ROUTES } from './subscription-page/subscription-page.routes';
import { EULAPage } from 'army-builder-shared/src/lib/global/settings/eula.page';
import { RegistrationPage } from 'army-builder-shared/src/lib/global/settings/registration/registration.page';
import { VerifyEmailPage } from 'army-builder-shared/src/lib/global/settings/verify-email/verify-email.page';
import { ResetPasswordRequestPage } from 'army-builder-shared/src/lib/global/settings/reset-password/reset-password-request.page';
import { ResetPasswordConfirmPage } from 'army-builder-shared/src/lib/global/settings/reset-password/reset-password-confirm.page';
import { GAME_IDS } from './game-id.token';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: 'home',
        component: HomePage,
        data: {
            hideSidebar: true
        }
    },
    {
        path: 'eula',
        component: EULAPage,
        data: {
            hideSidebar: true
        }
    },
    {
        path: 'register',
        component: RegistrationPage,
        data: {
            hideSidebar: true
        }
    },
    {
        path: 'verify-email',
        component: VerifyEmailPage,
        data: {
            hideSidebar: true
        }
    },
    {
        path: 'reset-password',
        component: ResetPasswordRequestPage,
        data: {
            hideSidebar: true
        }
    },
    {
        path: 'reset-password/confirm',
        component: ResetPasswordConfirmPage,
        data: {
            hideSidebar: true
        }
    },
    {
        path: 'pages/:pageId',
        component: ContentPageComponent,
        data: {
            hideSidebar: true,
            theme: 'content-page',
            gameId: GAME_IDS.FWW
        }
    },
    {
        path: 'fww',
        loadChildren: () => import('./fww/fww.module').then((m) => m.FWWModule),
        data: {
            gameId: GAME_IDS.FWW
        }
    },
    {
        path: 'ff',
        loadChildren: () => import('./ff/ff.module').then((m) => m.FFModule),
        data: {
            gameId: GAME_IDS.FF
        }
    },
    {
        path: 'fww2e',
        loadChildren: () => import('./fww2e/fww2e.module').then((m) => m.FWW2EModule),
        canActivate: [FeatureFlagGuard],
        data: {
            gameId: GAME_IDS.FWW2E,
            visualTheme: 'theme-pipboy',
            requiredFeature: 'fww2e'
        }
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule)
    },
    {
        path: 'settings',
        loadChildren: () => FalloutSettingsModule,
        data: {
            theme: 'content-page',
            hideSidebar: true
        }
    },
    {
        path: 'subscription',
        children: SUBSCRIPTION_PAGE_ROUTES,
        canActivate: [UserGuard],
        data: {
            theme: 'content-page',
            hideSidebar: true
        }
    },
    {
        path: 'support',
        canActivate: [UserGuard],
        component: SupportIssuesPage,
        data: {
            gameId: 'home',
            mode: 'user'
        }
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
